import { render, staticRenderFns } from "./GroupOfferDifferentPrice.vue?vue&type=template&id=07bf5654&scoped=true"
import script from "./GroupOfferDifferentPrice.vue?vue&type=script&lang=js"
export * from "./GroupOfferDifferentPrice.vue?vue&type=script&lang=js"
import style0 from "./GroupOfferDifferentPrice.vue?vue&type=style&index=0&id=07bf5654&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07bf5654",
  null
  
)

export default component.exports